import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgEngooSmallLogo: React.FunctionComponent<
  SVGProps<SVGSVGElement>
> = props => (
  <svg viewBox="0 0 276 150" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M83.9 61.38a9.07 9.07 0 11-18.14 0 9.07 9.07 0 0118.14 0z"
      fill="#459AF8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M211.42 61.38a9.07 9.07 0 11-18.13 0 9.07 9.07 0 0118.13 0z"
      fill="#EB4A57"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.97 119.58c-16.46 0-29.96-12.56-31.52-28.62h.03l-.03-30.75c1-16.62 14.66-29.79 31.52-29.79 16.97 0 30.83 13.32 31.68 30.09v28.98c-.85 16.77-14.7 30.09-31.68 30.09zm71.77-21.35L121.9 70.78V60.5h.05C121.69 27.05 94.49 0 60.97 0 27.46 0 .26 27.05 0 60.5v29C.26 122.94 27.46 150 60.97 150c28.9 0 53.08-20.1 59.37-47.08h8.01c6.15 0 4.4-4.69 4.4-4.69z"
      fill="#3B9CFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M214.52 119.58c-16.47 0-30.08-12.56-31.64-28.62l.14-30.75c1-16.62 14.63-29.79 31.5-29.79 16.97 0 30.82 13.32 31.67 30.09v28.98c-.85 16.77-14.7 30.09-31.67 30.09zm60.97-59.07C275.24 27.05 248.04 0 214.52 0 181 0 153.8 27.05 153.55 60.5l.23 9.48-11.16 28.25s-1.75 4.69 4.39 4.69h8.14c6.3 26.97 30.47 47.08 59.37 47.08 33.03 0 59.94-26.26 60.97-59.04V60.51z"
      fill="#F64C58"
    />
  </svg>
);
/* eslint-enable max-len */

export default SvgEngooSmallLogo;
